module.exports = __webpack_public_path__ + "img/pay.54ade147.svg";